import React, { Component } from "react";

class FailMessageModal extends Component {
  render() {
    const { binding, selRoleId, showModalFailMessage, handleCloseModalFailMessage } = this.props;

    let formGroup = {
      marginBottom: "20px", 
      justifyContent: "center", 
      display: "inline-flex"
    };

    let formLabel = {
      color: "#949494", 
      margin: "auto", 
      textAlign: "left", 
      width: "80px"
    };

    let formControl = {
      width: "220px", 
      height: "40px", 
      border: "1.5px solid #C7C7C7"
    };

    let t2 = {
      color: "#F6490D", 
      fontWeight: "600", 
      fontSize: "14px", 
      textAlign: "left"
    };

    let modalDialog = {
      width: "400px",
      margin: "200px auto",
    };
    
    let modalBody = {
        padding: "0px 49px",
    };

    let modalFooter = {
        textAlign: "center",
        border: "0",
        margin: "-20px 0 15px",
    };

    let modalFooterButton = {
        padding: "10px 50px",
        borderRadius: "30px",
        margin: "0",
    };

    let modalContent = {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      width: "100%",
      pointerEvents: "auto",
      backgroundColor: "#fff",
      backgroundClip: "padding-box",
      border: "1px solid rgba(0, 0, 0, .2)",
      borderRadius: "20px",
    };

    let modalHeader = {
      flexDhrink: "0",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "3rem 2rem",
      borderBottom: "0",
      textAlign: "center",
      borderTopLeftRadius: "calc(0.3rem - 1px)",
      borderTopRightRadius: "calc(0.3rem - 1px)",
  }

    let modalTitle = {
      marginBottom: "0",
      lineHeight: "1.5",
      fontSize: "2.5rem",
      fontWeight: "600",
      color: "#191A1C",
    }

    if (window.innerWidth <= 480) {
      modalBody.padding = "0px 25px";
      modalDialog.maxWidth = "330px";
      modalDialog.margin = "100px auto";
      modalTitle.fontSize = "2rem";
      formControl.width = "200px";
    }

    return (
      <div className="container mt-3">
        <div className={`modal ${selRoleId === binding.role_id && showModalFailMessage}`} id="myModa2" tabIndex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
          <div className="modal-dialog" style={modalDialog}>
            <div className="modal-content" style={modalContent}> 
              <div className="modal-header" style={modalHeader}>
                <h4 className="modal-title" style={modalTitle}>綁定失敗</h4>
              </div>
              <div className="modal-body" style={modalBody}> 
                <div className="form-group" style={formGroup}>
                  <label style={formLabel}>綁定遊戲</label>
                    <input type="text" className="form-control" style={formControl} value={binding.game_name} disabled />
                  </div>
                  <div className="form-group" style={formGroup}>
                    <label style={formLabel}>伺服器</label>
                    <input type="text" className="form-control" style={formControl} value={binding.server_name} disabled />
                  </div>
                  <div className="form-group" style={formGroup}>
                    <label style={formLabel}>角色ID</label>
                    <input type="text" className="form-control" style={formControl} value={binding.role_id} disabled />
                  </div>
                  <p className="t2" style={t2}>{binding.memo}</p>
              </div>
              <div className="modal-footer" style={modalFooter}>
                  <button type="button" className="btn btn-danger" style={modalFooterButton} onClick={handleCloseModalFailMessage}>關閉</button>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

export default FailMessageModal;
